import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import CoreChip from "../../../app/core/components/CoreChip/CoreChip";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import { TABLE_ROWS_NUMBER } from "../../../utils/constants/tables";
// import { labelForFilterPractice } from "../../../utils/functions/filters";
import AutocompleteFilter from "../../../app/core/components/CoreFilter/components/AutocompleteFilter/AutocompleteFilter";
import CoreFilter from "../../../app/core/components/CoreFilter/CoreFilter";
import { STATUS_OPTIONS } from "../../../utils/constants/filters";
import {
  useGetPracticeManagementQuery,
  useGetPracticesServicesQuery,
} from "../../api/admin/gestisciPraticheApi";
import { useGetUsersQuery } from "../../api/admin/gestisciUtentiApi";
import practiceManagementSlice from "./GestisciPraticheSlice";
import GestisciPraticaButtonCockpit from "./GestisciPraticheTable/ControlCockPit/GestisciPraticaButtonCockpit";
// import GestisciPraticaFilter from "./GestisciPraticheTable/ControlCockPit/GestisciPraticaFilter";
import { t } from "i18next";
import { useLocation, useParams } from "react-router-dom";
import CoreBack from "../../../app/core/components/CoreBack/CoreBack";
import CoreSearchBar from "../../../app/core/components/CoreSearch/CoreSearch";
import { selectAllFilters } from "../../../app/globalFiltersSlice";
import {
  removeGlobalFilter,
  setGlobalFilter,
  setMultipleGlobalFilters,
} from "../../../app/globalFiltersSlice.js";
import { ROLE } from "../../../utils/constants/profiles.js";
import useSyncFilterWithGlobalFilters from "../../../utils/hookCustom";
import { useGetCompaniesQuery } from "../../api/admin/adminCompany";
import { useGetCommercialistaQuery } from "../../api/admin/gestisciCommercialistiApi";
import { useGetStudiosQuery } from "../../api/admin/gestisciStudioApi";
import GestionePraticheTable from "./GestisciPraticheTable/Table/GestisciPraticheTable";

const GestisciPratichePage = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { id } = useParams();
  const USER_FROM_LOCATION = { id: id, name: location.state, surname: "" };
  const role = useSelector((state) => state.app.role);
  const globalFilters = useSelector(selectAllFilters);
  const [debouncedInputStudioValue, setDebouncedInputStudioValue] =
    useState("");
  const [selectedUser, setSelectedUser] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedInputUserValue, setDebouncedInputUserValue] = useState("");
  const [debouncedInputOperatorValue, setDebouncedInputOperatorValue] =
    useState("");
  const [debouncedInputCompanyValue, setDebouncedInputCompanyValue] =
    useState("");

  const [page, setPage] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  });
  const [filter, setFilter] = useState({
    status: "",
    serviceId: "",
    studioId: "",
    adminId: "",
    userId: "",
    companyId: "",
  });
  const [orderDirection, setOrderDirection] = useState("desc");
  const [valueToOrderBy, setValueToOrderBy] = useState("createdAt");

  const {
    data: practicesData,
    isLoading: practicesLoading,
    isFetching: practicesFetching,
    refetch,
  } = useGetPracticeManagementQuery({
    page,
    userFilter: searchTerm,
    filter,
    orderDirection,
    valueToOrderBy,
  });

  const {
    data: usersData,
    isLoading: isUsersLoading,
    isFetching: isUsersFetching,
  } = useGetUsersQuery({
    page: page,
    value: debouncedInputUserValue,
  });

  const { data: operatorsData } = useGetCommercialistaQuery({
    page: page,
    value: debouncedInputOperatorValue,
  });

  const {
    data: companiesList,
    isLoading: isCompanySelectLoading,
    isFetching: isCompanySelectFetching,
  } = useGetCompaniesQuery({
    startRow: 0,
    endRow: 50,
    query: debouncedInputCompanyValue,
  });

  const { data: practiceServicesData, isLoading: loadingService } =
    useGetPracticesServicesQuery();

  const { data: adminStudio } = useGetStudiosQuery({
    ...page,
    value: debouncedInputStudioValue,
  });

  const handleRemoveFilter = (f) => {
    let newFilter = { ...filter };
    Object.entries(newFilter).forEach(([k, v]) => {
      if (v === f) newFilter[k] = "";
    });
    setFilter(newFilter);
    dispatch(practiceManagementSlice.actions.setTableFilters(newFilter));
  };

  const handleRefecthDocuments = () => {
    refetch();
  };

  const handleResetGlobalFilter = (key) => {
    dispatch(setGlobalFilter({ key, value: "" }));
    handleRemoveFilter(key);
  };

  useSyncFilterWithGlobalFilters(setFilter);

  if (practicesLoading) {
    return <CoreSpinner />;
  }

  const transformFilters = (filtersArray) => {
    const filterObject = {
      status: "",
      serviceId: "",
      studioId: "",
      adminId: "",
      userId: "",
      companyId: "",
    };

    filtersArray.forEach((filter) => {
      if (
        filter.key &&
        Object.prototype.hasOwnProperty.call(filterObject, filter.key)
      ) {
        filterObject[filter.key] = filter.value || "";
      }
    });

    return filterObject;
  };

  const handleFiltersChange = (newFilters) => {
    // Trasforma i filtri nel formato desiderato
    const transformedFilters = transformFilters(newFilters);

    // Ora puoi usare l'oggetto trasformato
    setFilter(transformedFilters);
  };

  const handleGlobalFiltersApply = (filters) => {
    // Separa i filtri con valori validi da quelli undefined/vuoti
    const validFilters = [];
    const filtersToRemove = [];

    filters.forEach((filter) => {
      if (filter.value !== undefined && filter.value !== "") {
        // Filtro con valore valido - mantienilo
        validFilters.push(filter);
      } else {
        // Filtro undefined o vuoto - rimuovilo
        filtersToRemove.push(filter.key);
      }
    });

    // Rimuovi i filtri undefined/vuoti dallo state
    filtersToRemove.forEach((filterKey) => {
      dispatch(removeGlobalFilter(filterKey));
    });

    // Imposta solo i filtri con valori validi
    if (validFilters.length > 0) {
      dispatch(setMultipleGlobalFilters(validFilters));
    }
  };

  return (
    <>
      <div className="flex flex-col">
        <div className="w-full flex items-center">
          {location.state && <CoreBack />}
          <h2>{t("ManagePractices")}</h2>
        </div>

        <div className="flex flex-row -mt-16 justify-end space-x-2">
          <CoreFilter
            onFiltersChange={handleFiltersChange}
            onGlobalFiltersApply={handleGlobalFiltersApply}
            initialFilters={globalFilters}
          >
            {ROLE.ADMIN === role && (
              <AutocompleteFilter
                label="Cerca Studio"
                placeholder="Digita nome studio..."
                options={adminStudio?.Data?.items}
                filterKey="studioId"
                getOptionValue={(option) => option.id}
                getOptionLabel={(option) => option.name}
                allowGlobal={true}
              />
            )}
            {role !== ROLE.OPERATOR && (
              <AutocompleteFilter
                label="Cerca Operatore"
                placeholder="Digita nome operatore..."
                options={operatorsData?.Data?.items}
                filterKey="adminId"
                getOptionValue={(option) => option.id}
                getOptionLabel={(option) => `${option.name} ${option.surname}`}
                allowGlobal={true}
              />
            )}

            <AutocompleteFilter
              label="Cerca Cliente"
              placeholder="Digita nome cliente..."
              options={usersData?.Data?.items}
              filterKey="userId"
              getOptionValue={(option) => option.id}
              getOptionLabel={(option) => `${option.name} ${option.surname}`}
              allowGlobal={true}
            />

            <AutocompleteFilter
              label="Cerca Azienda"
              placeholder="Digita nome azienda..."
              options={companiesList?.Data?.items}
              filterKey="companyId"
              getOptionValue={(option) => option.id}
              getOptionLabel={(option) => `${option.name}`}
            />
            <AutocompleteFilter
              label="Cerca Servizio"
              placeholder="Digita nome servizio..."
              options={practiceServicesData?.Data?.items}
              filterKey="serviceId"
              getOptionValue={(option) => option.id}
              getOptionLabel={(option) => `${option.name}`}
            />
            <AutocompleteFilter
              label="Cerca per Stato"
              placeholder="Seleziona stato..."
              options={STATUS_OPTIONS}
              filterKey="status"
              getOptionValue={(option) => option.value}
              getOptionLabel={(option) => `${option.label}`}
            />
          </CoreFilter>

          {/* {Object.entries(filter)?.map(
            ([k, v]) =>
              v !== "" && (
                <CoreChip
                  key={v}
                  label={labelForFilterPractice(
                    k,
                    v,
                    practiceServicesData,
                    adminStudio,
                    operatorsData,
                    companiesList,
                    usersData
                  )}
                  variant="outlined"
                  onDelete={() => {
                    Object.values(globalFilters).some((v) => v !== "")
                      ? handleResetGlobalFilter(k)
                      : handleRemoveFilter(v);
                  }}
                />
              )
          )}

          <GestisciPraticaFilter
            filter={filter}
            setFilter={setFilter}
            services={practiceServicesData}
            isServiceLoading={loadingService}
            slice={practiceManagementSlice}
            studios={adminStudio}
            selectedUser={selectedUser}
            setSelectedUser={setSelectedUser}
            users={usersData}
            setDebouncedInputStudioValue={setDebouncedInputStudioValue}
            operators={operatorsData}
            setDebouncedInputOperatorValue={setDebouncedInputOperatorValue}
            companies={companiesList}
            isCompanyLoading={isCompanySelectFetching || isCompanySelectLoading}
            setDebouncedInputCompanyValue={setDebouncedInputCompanyValue}
            setDebouncedInputUserValue={setDebouncedInputUserValue}
          /> */}
        </div>

        <div className="flex flex-col">
          <div>
            <div className="flex flex-row justify-between mt-10 items-center">
              {/* Controls */}
              <div className="flex flex-row justify-between items-center w-2/3 space-x-4">
                <CoreSearchBar
                  isLoading={isUsersLoading || isUsersFetching}
                  placeholder={t("ExtSearchUser")}
                  searchTerm={searchTerm}
                  handleChange={setSearchTerm}
                />

                <div className="w-full">
                  <GestisciPraticaButtonCockpit
                    onRefetch={handleRefecthDocuments}
                  />
                </div>
              </div>
            </div>
            <GestionePraticheTable
              page={page}
              setPage={setPage}
              data={practicesData?.Data}
              valueToOrderBy={valueToOrderBy}
              setValueToOrderBy={setValueToOrderBy}
              orderDirection={orderDirection}
              setOrderDirection={setOrderDirection}
              isLoading={practicesLoading || practicesFetching}
              totalPages={Math.ceil(
                practicesData?.Data?.count / TABLE_ROWS_NUMBER || 1
              )}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default GestisciPratichePage;
